import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import UserReviews from './components/UserReviews';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫画网',
  url: 'http://nikson.cn/',
  description: '韩漫画网提供下拉式免费漫画在线观看服务，涵盖韩国漫画大全资源。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://nikson.cn/category/all?search={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <SEO
        title="下拉式免费漫画 | 韩漫在线观看"
        description="韩漫画网提供下拉式免费漫画在线观看服务，涵盖恋爱漫画、热血动作、奇幻冒险、都市剧情等韩国漫画大全资源。操作简单，内容全面，是您收藏韩国漫画的最佳选择。"
        keywords="韩漫画网,下拉式免费漫画,韩漫在线观看,韩国漫画大全,韩漫,免费漫画,在线漫画"
        canonicalUrl="http://nikson.cn/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <UserReviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}